const maxSizeMB = Number(process.env.REACT_APP_MAX_FILE_SIZE_MB || "500");
const maxSizeBytes = maxSizeMB * 1024 * 1024;

export const getLink = (path) => {
  if (!path) {
    return "/images/defaultImage/avatar.jpg";
  }
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  const baseUrl = process.env.REACT_APP_SERVER_URL?.replace(/\/$/, "");
  if (!baseUrl) {
    console.error("REACT_APP_API_URL is not defined");
    throw new Error("API URL is not configured");
  }
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
};

export const checkFileSize = (file) => {
  return file.size <= maxSizeBytes;
};
